import me from '../assets/ana.jpg';
import clubsnet from '../assets/projects/clubsnet.png';
import dolphiny from '../assets/projects/dolphiny.png';
import or from '../assets/projects/distribution_argan.png';
import audiobook from '../assets/projects/audiobook.png';
import photopro from '../assets/projects/photopro.png';
import ea from '../assets/projects/ea.png';
import learnit from '../assets/projects/learnit.png';
import portfolio from '../assets/projects/portfolio.png';
import safepdf from '../assets/projects/safepdf.png';
import tree2fs from '../assets/projects/tree2fs.jpg';
import vitacv from '../assets/projects/vita-cv.png';
import Knowlege_clash from '../assets/projects/Knowlege_clash.png';
import leafdoctorai from '../assets/projects/leafdoctorai.png';
import taha from '../assets/testimonial/taha.jpg';
import achak from '../assets/testimonial/achak.jpg';
import essagar from '../assets/testimonial/essagar.jpg';
import ciam from '../assets/volunteering/ciam.jpg';
import gdsclead from '../assets/volunteering/gdsclead.png';
import devfest from '../assets/volunteering/devfest.jpg';
import orangeAI from '../assets/volunteering/orangeAI.jpg';
import seeds from '../assets/volunteering/seeds.jpg';
import chatbot from '../assets/volunteering/chatbot.jpg';
import techathon from '../assets/volunteering/techathon.png';

import git from '../assets/volunteering/talks/git.jpg';
import ml_intro from '../assets/volunteering/talks/ml_intro.jpg';
import python_init from '../assets/volunteering/talks/python_init.jpg';
import supervised_ml from '../assets/volunteering/talks/supervised_ml.jpg';
import want_gdsc_lead from '../assets/volunteering/talks/want_gdsc_lead.jpg';
import airflow from '../assets/volunteering/talks/airflow.jpg';
import DE101 from '../assets/volunteering/talks/DE101.jpg';

export default {
  me,
  clubsnet,
  dolphiny,
  or,
  ea,
  audiobook,
  learnit,
  taha,
  achak,
  essagar,
  ciam,
  gdsclead,
  devfest,
  orangeAI,
  seeds,
  chatbot,
  leafdoctorai,
  Knowlege_clash,
  portfolio,
  techathon,
  want_gdsc_lead,
  airflow,
  DE101,
  supervised_ml,
  python_init,
  ml_intro,
  git,
  photopro,
  safepdf,
  tree2fs,
  vitacv,
};
